/** Default map view: MENA region at maximum zoom-out. */
export const MENA_MAP_CENTER = { lat: 28, lng: 38 } as const;
export const MENA_DEFAULT_ZOOM = 3;
export const FIELD_MARKER_ZOOM = 6;

/**
 * Below this zoom, nearby fields are grouped into count bubbles.
 * At this zoom and above, individual markers are shown (dense areas may still
 * spiderfy briefly at the threshold).
 */
export const FIELD_CLUSTER_DISABLE_AT_ZOOM = 10;

/** Default cluster pixel radius around mid zooms (see FieldMarkerCluster for zoom curve). */
export const FIELD_CLUSTER_MAX_RADIUS_PX = 55;
